module.exports = __webpack_public_path__ + "pagerduty-logo.png";